import { TieVoteIcon} from "./TieVoteIcon";

export default TieVoteIcon;
